module.exports = __webpack_public_path__ + "media/images/top/color-8ac6d2ad26dabde7c49e5bfd44a5caff.jpg";